import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import { Fonts, Spacings } from '@styles/index';
import Image from '@base/Image';
import PropTypes from 'prop-types';

const Container = styled.div``;

const Title = styled(P1)`
  margin-top: ${Spacings.SPACING_3B};
  font-weight: ${Fonts.SEMIBOLD};
`;

const SubTitle = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
  font-weight: ${Fonts.LIGHT};
  color: var(--color-text-secondary);
`;

const ErrorState = ({ iconUrl, title, subtitle }) => {
  return (
    <Container>
      <Image
        width={Spacings.SPACING_16B}
        height={Spacings.SPACING_16B}
        src={iconUrl}
        alt="-"
      />
      <Title>{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
    </Container>
  );
};

ErrorState.propTypes = {
  iconUrl: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

ErrorState.defaultProps = {
  iconUrl: 'educator/one-to-one-live-mentoring/previous-notes-error-state.svg',
  title: 'Something went wrong',
  subtitle: 'There was an issue connecting with the server. Please try again'
};

export default ErrorState;
